import { createPortal } from 'react-dom'

import BoardPoll from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardPoll/BoardPoll'
import type { PollTarget } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardHtml/useBoardHtml'

interface BoardPollPortalProps {
  target: PollTarget
}

const BoardPollPortal = ({ target }: BoardPollPortalProps) =>
  createPortal(<BoardPoll pollKey={target.pollKey} question={target.question} />, target.element)

export default BoardPollPortal
